import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { Router } from '@angular/router';
import * as alertify from 'alertifyjs';

export default class HttpBase {

  constructor(private http: Http, protected router: Router) {}

  httpPost(url: string, object: any, showPopupOnError = true, redirectToLoginIfNotAuthorized = true): Observable<Response> {
    this.putLoader();
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const options = new RequestOptions({
      headers,
      withCredentials: true
    });

    return this.http.post(url, JSON.stringify(object), options)
    .map((r: Response) => r)
    .catch((r: Response) => {
      if (r.status === 401 && redirectToLoginIfNotAuthorized) {
        this.goToLoginPage();
      } else if (r.status !== 401 && r.status !== 422 && showPopupOnError) {
        alertify.alert('Crim Error', 'Your request cannot be processed at this time.  Please try again later.');
      }

      return Observable.of(r);
    })
    .finally(() => {
      this.removeLoader();
    });
  }

  httpDelete(url: string, showPopupOnError = true, redirectToLoginIfNotAuthorized = true): Observable<Response> {
    this.putLoader();
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const options = new RequestOptions({
      headers,
      withCredentials: true
    });

    return this.http.delete(url, options)
    .map((r: Response) => r)
    .catch((r: Response) => {
      if (r.status === 401 && redirectToLoginIfNotAuthorized) {
        this.goToLoginPage();
      } else if (r.status !== 401 && r.status !== 422 && showPopupOnError) {
        alertify.alert('Crim Error', 'Your request cannot be processed at this time.  Please try again later.');
      }

      return Observable.of(r);
    })
    .finally(() => {
      this.removeLoader();
    });
  }

  httpGet(url, showPopupOnError = true, redirectToLoginIfNotAuthorized = true): Observable<Response> {
    this.putLoader();
    return this.http.get(url, { withCredentials: true })
    .map((r: Response) => r)
    .catch((r: Response) => {
      if (r.status === 401 && redirectToLoginIfNotAuthorized) {
        this.goToLoginPage();
      } else if (r.status !== 401 && r.status !== 422 && showPopupOnError) {
        alertify.alert('Crim Error', 'Your request cannot be processed at this time.  Please try again later.');
      }

      return Observable.of(r);
    })
    .finally(() => {
      this.removeLoader();
    });
  }

  goToLoginPage() {
    this.router.navigate(['login']);
  }

  private putLoader() {
    const loaderElement = document.getElementById('loader');
    loaderElement.className = 'loader';

    const screenDisableElement = document.getElementById('screen-disable');
    screenDisableElement.className = 'screen-disable';
  }

  private removeLoader() {
    const loaderElement = document.getElementById('loader');
    loaderElement.className = '';

    const screenDisableElement = document.getElementById('screen-disable');
    screenDisableElement.className = '';
  }
}



// WEBPACK FOOTER //
// ./src/models/httpBase.ts